import { createApiActionTypes } from '../../../store';

export const UPDATE_PREV_LOCATION = 'UPDATE_PREV_LOCATION';
export const UPDATE_PREV_CRUMBS = 'UPDATE_PREV_CRUMBS';
export const TOGGLE_NAVBAR = 'TOGGLE_NAVBAR';

export const GET_INTEGRATIONS = createApiActionTypes('GET_INTEGRATIONS');
export const GET_ORGANISATION_TYPES = createApiActionTypes(
	'GET_ORGANISATION_TYPES',
);
